export default function Footer({ showNav }) {
    const year = new Date().getFullYear();
    const sidebarWidth = showNav ? 250 : 0;

    return (
        <footer
            style={{
                position: 'fixed',
                bottom: 0,
                left: `${sidebarWidth}px`,
                width: `calc(100% - ${sidebarWidth}px)`,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f8f9fa',
                padding: '0.75rem 0',
                borderTop: '1px solid #dee2e6',
                zIndex: 10,
				transition: 'left 0.5s ease, width 0.5s ease'
            }}
        >
            <span className="small text-muted">
                © {year} Safite. Todos los derechos reservados.
            </span>
        </footer>
    );
}
